<template>
  <div v-if="isBlackFridayStart">
    <div class="side-box" :class="{ close: !visible }">
      <a
        class="side-get-btn"
        href="javascript:;"
        @click="showBlackFridayPopup"
        >{{ letter.claimCoupon }}</a
      >
      <a
        class="side-rule-btn"
        href="javascript:;"
        @click="showBlackFridayRulePopup"
        >{{ letter.ruleTitleText }}</a
      >
      <a class="side-box-close" href="javascript:;" @click="switchSideShow">
        <em class="side-box-close-arrow"></em>
      </a>
    </div>
    <transition name="fade" mode="out-in">
      <BlackFridayRulePopup
        v-if="isShowRulePopup"
        @closeRulePopup="hideBlackFridayRulePopup"
      ></BlackFridayRulePopup>
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { BLACK_FRIDAY_BASIC } from '@store/officialStore/event';
import {
  SET_VISIBLE_BLACK_FRIDAY_POPUP,
  SET_BLACK_FRIDAY_START
} from '@store/officialStore/index';
import { getDefaultPayType } from '@store/officialStore/storager';
import login from '@mixins/officialStore/login';
import BlackFridayRulePopup from './BlackFridayRulePopup.vue';

export default {
  name: 'sideFloatingWindow',
  mixins: [login],
  props: {},
  data() {
    return {
      isShowRulePopup: false,
      visible: true
    };
  },
  computed: {
    ...mapState({
      welfareBtnRecord: state => state.welfareBtnRecord,
      letter: state => state.letter,
      lang: state => state.lang,
      isUidLogin: state => state.login.isUidLogin,
      uid: state => state.login.uid,
      isLogin: state => state.login.isLogin,
      isBlackFridayStart: state => state.isBlackFridayStart
    })
  },
  methods: {
    ...mapMutations({
      setVisibleBlackFridatPopup: SET_VISIBLE_BLACK_FRIDAY_POPUP,
      setBlackFridayStart: SET_BLACK_FRIDAY_START
    }),
    switchSideShow() {
      this.visible = !this.visible;
    },
    showBlackFridayPopup() {
      if (!this.isLogin || this.isUidLogin) {
        this.login();
        return;
      }
      this.setVisibleBlackFridatPopup(true);
    },
    showBlackFridayRulePopup() {
      this.isShowRulePopup = true;
    },
    hideBlackFridayRulePopup() {
      this.isShowRulePopup = false;
    },
    async initBlackFriday() {
      try {
        const defaultPayType = getDefaultPayType();
        const res = await this.$store.dispatch(BLACK_FRIDAY_BASIC, {
          currency: defaultPayType?.currency || 'USD'
        });
      } catch (err) {
        // -20015 -20016活动未开始,活动已结束，未在活动时间，不显示
        if (err.code == -20015 || err.code == -20016) {
          this.setBlackFridayStart(false);
        }
      }
    }
  },
  mounted() {
    this.initBlackFriday();
  },
  components: {
    BlackFridayRulePopup
  }
};
</script>

<style lang="scss" scoped>
.side-box {
  z-index: 8;
  text-align: center;
  position: fixed;
  top: 360px;
  left: 0;
  width: 220px;
  height: 481px;
  box-sizing: border-box;
  background-size: cover;
  @psetbg ('floating-window-bf.png', false);
  transition-duration: 0.3s;

  &-close {
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    right: -24px;
    width: 24px;
    height: 36px;
    margin: auto;
    &-arrow {
      display: block;
      width: 8px;
      height: 16px;
      @psetbg ('left-side-arrow.png', false);
      transform: rotate(180deg);
    }
  }

  &.close {
    transform: translateX(-100%);

    .side-box-close-arrow {
      transform: rotate(0);
    }
  }

  .side-get-btn {
    margin: 0 12px;
    position: absolute;
    top: 349px;
    cursor: pointer;
    width: 197px;
    height: 58px;
    @psetbg ('get-coupon-side-btn.png', false);
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: SourceHanSansSC-Medium;
    font-size: 24px;
    line-height: 24px;
    color: #ffffff;
  }

  .side-rule-btn {
    margin-top: 436px;
    display: inline-block;
    font-family: SourceHanSansCN-Light;
    font-size: 18px;
    line-height: 18px;
    color: #ffffff;
  }
}
</style>
